import { createModel, RematchDispatch } from '@rematch/core';
import { RootModel } from '../models';
import * as AuthService from '../../services/auth.service';

export const storeName = 'user';

export interface initialValuesType {
  user: any;
}

export const initialValues: initialValuesType = {
  user: undefined,
};

const user: any = createModel<RootModel>()({
  state: initialValues, // initial state
  reducers: {
    updateUserDetail(state, payload) {
      return {
        ...state,
        user: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<typeof user>) => ({
    getUserDetailAsync() {
      return AuthService.getUserDetail().then((res: any) => {
        const { data } = res;
        data.permissions = data.roles.flatMap((r: any) => r.permissions).map((p: any) => p.name);
        dispatch.user.updateUserDetail(data);
        return data;
      });
    },
    hasPermission(payload, state) {
      const { user: detail } = state[storeName];
      if (!detail || !detail.permissions || !detail.permissions.length) {
        return false;
      }

      return detail.permissions.includes(payload);
    }
  }),
});

export default user;
